// @flow

export function formatDueDate(stringDate: string): string {
  const date = new Date(stringDate);

  const month = date.getMonth() + 1;
  const day = date.getDate();

  const hours = date.getHours();
  const minutes = date.getMinutes();

  return `${pad(day)}/${pad(month)}, ${pad(hours)}:${pad(minutes)}`;
}

function pad(n: number): string {
  return String(n).padStart(2, '0');
}
